import { render, staticRenderFns } from "./Donut.vue?vue&type=template&id=ddf06c28&scoped=true"
import script from "./Donut.vue?vue&type=script&lang=js"
export * from "./Donut.vue?vue&type=script&lang=js"
import style0 from "./Donut.vue?vue&type=style&index=0&id=ddf06c28&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf06c28",
  null
  
)

export default component.exports